import { Modal } from "@maysoft/common-component-react"
import { useEffect, useState } from "react"
import EmailConfigForm from "../container/emailConfig"
import Strings from "constants/strings"
import BasicInfoSection from "../container/baseInfo"
import { SettingProps } from "./simpleConfigModal"


type EmailConfig = {
    MailAddress: string
    Credential: string
    Host: string
    Port: string
    EnableSsl: boolean
    SenderName: string
}

const defaultValue: EmailConfig = {
    MailAddress: "",
    Credential: "",
    Host: "",
    Port: "",
    EnableSsl: false,
    SenderName: ""
}

const EmailConfigPopup = ({
    serviceName,
    tenantName,
    visibled,
    value,
    onClose,
    onSubmit
}: SettingProps) => {
    const [config, setConfig] =
        useState<EmailConfig>(defaultValue)

    useEffect(() => {
        try {
            setConfig(JSON.parse(value))
        } catch {
            setConfig(defaultValue)
        }
    }, [value])

    return (
        <Modal
            visible={visibled}
            maxWidth="md"
            fullWidth
            title="Email Configuration"
            hasActionButton
            buttonAction={Strings.Common.SAVE}
            onClose={onClose}
            onAction={() =>
                onSubmit(JSON.stringify(config))
            }
        >
            <BasicInfoSection
                title={Strings.SETTING.BASIC}
                items={[
                    {
                        label: Strings.SETTING.SERVICE,
                        value: serviceName
                    },
                    {
                        label: Strings.SETTING.TENANT,
                        value: tenantName
                    }
                ]}
            />

            <EmailConfigForm
                value={config}
                onChange={setConfig}
            />
        </Modal>
    )
}

export default EmailConfigPopup